<template>
  <div class="xv_view" id="Visitors">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">Visitors</label>
      </div>
      <div class="xv_actions"></div>
    </div>
    <div class="xv_table">
      <div class="xv_table_title">
        <div>
          <span>Visitors (128) for today</span>
        </div>
        <button class="sec_btn" @click="table_filter()">
          Filter
          <span class="mdi mdi-filter-menu"></span>
        </button>
      </div>

      <div class="filter_wrap">
        <div class="left_filter" v-if="left_filter == true">
          <div class="header_section top">
            <div>
              <span class="main_title">
                Filter
                <span class="mdi mdi-filter-menu"></span>
              </span>
            </div>
            <div>
              <span class="option">Reset</span>
            </div>
          </div>
          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Date</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="xv_datepicker">
                <span class="mdi mdi-calendar-month"></span>
                <vc-date-picker
                  mode="range"
                  v-model="selectedDate"
                  :popover="{ visibility: 'click' }"
                  :input-props="{
                    class: 'picker_input',
                    placeholder: 'Select dates',
                    readonly: true
                  }"
                  :masks="{ input: 'DD/MM/YY' }"
                />
              </div>
            </div>
          </div>

          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Office</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <multiselect
                v-model="multiselect"
                :options="[
                  'Alphabet',
                  'Nestle',
                  'Tencent',
                  'Facebook',
                  'Alibaba'
                ]"
                :multiple="true"
              ></multiselect>
            </div>
          </div>

          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Status</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Ok</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-6" name="checkbox-6"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Block</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <table class="visitor_table">
          <thead>
            <tr>
              <th>Date</th>
              <th style="text-align:center">Name</th>
              <th style="text-align:center">Contact</th>
              <th style="text-align:center">Meeting User</th>
              <th style="text-align:center;width:10%">Status</th>
              <th style="text-align:center;width:5%"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>02-Jan-2020 10:30am</td>
              <td>Phillippa Bass</td>
              <td>
                <div>+1-202-555-0197</div>
                <div>bass@gmail.com</div>
              </td>
              <td>Anthony Cook</td>
              <td class="status_1">
                <span>Ok</span>
              </td>
              <td>
                <label class="mdi mdi-clipboard-text-outline" id="declaration-1"></label>
                <b-popover target="declaration-1" triggers="hover" placement="left">
                  <template v-slot:title>Declaration</template>
                  Sed eu justo ullamcorper, hendrerit urna quis, varius lorem.
                </b-popover>
              </td>
            </tr>
            <tr>
              <td>02-Jan-2020 10:30am</td>
              <td>Becky Ross</td>
              <td>
                <div>+1-202-555-0197</div>
                <div>becky@gmail.com</div>
              </td>
              <td>Ellis Morrow</td>
              <td class="status_2">
                <span>Block</span>
              </td>
              <td>
                <label class="mdi mdi-clipboard-text-outline" id="declaration-2"></label>
                <b-popover target="declaration-2" triggers="hover" placement="left">
                  <template v-slot:title>Declaration</template>
                  Nunc consectetur turpis venenatis ligula rutrum vulputate.
                </b-popover>
              </td>
            </tr>
            <tr>
              <td>02-Jan-2020 10:30am</td>
              <td>Hasnain Pace</td>
              <td>
                <div>+1-202-555-0197</div>
                <div>pace@gmail.com</div>
              </td>
              <td>Yasmine Hoffman</td>
              <td class="status_1">
                <span>Ok</span>
              </td>
              <td>
                <label class="mdi mdi-clipboard-text-outline" id="declaration-3"></label>
                <b-popover target="declaration-3" triggers="hover" placement="left">
                  <template v-slot:title>Declaration</template>
                  Praesent tincidunt augue nec varius bibendum.
                </b-popover>
              </td>
            </tr>

            <tr>
              <td>02-Jan-2020 10:30am</td>
              <td>Rudra Roche</td>
              <td>
                <div>+1-202-555-0197</div>
                <div>rudra@gmail.com</div>
              </td>
              <td>Joseph Davis</td>
              <td class="status_1">
                <span>Ok</span>
              </td>
              <td>
                <label class="mdi mdi-clipboard-text-outline" id="declaration-4"></label>
                <b-popover target="declaration-4" triggers="hover" placement="left">
                  <template v-slot:title>Declaration</template>
                  Mauris a nulla fringilla, tristique turpis sed, tincidunt
                  tortor.
                </b-popover>
              </td>
            </tr>

            <tr>
              <td>02-Jan-2020 10:30am</td>
              <td>Viola Francis</td>
              <td>
                <div>+1-202-555-0197</div>
                <div>viola@gmail.com</div>
              </td>
              <td>Franklin Clinton</td>
              <td class="status_2">
                <span>Block</span>
              </td>
              <td>
                <label class="mdi mdi-clipboard-text-outline" id="declaration-5"></label>
                <b-popover target="declaration-5" triggers="hover" placement="left">
                  <template v-slot:title>Declaration</template>
                  Fusce fringilla dolor in eros feugiat imperdiet.
                </b-popover>
              </td>
            </tr>

            <tr>
              <td>02-Jan-2020 10:30am</td>
              <td>Sumaya Jacobson</td>
              <td>
                <div>+1-202-555-0197</div>
                <div>sumaya@gmail.com</div>
              </td>
              <td>Jasmine Morgan</td>
              <td class="status_1">
                <span>Ok</span>
              </td>
              <td>
                <label class="mdi mdi-clipboard-text-outline" id="declaration-6"></label>
                <b-popover target="declaration-6" triggers="hover" placement="left">
                  <template v-slot:title>Declaration</template>
                  Nam accumsan ex at consectetur convallis.
                </b-popover>
              </td>
            </tr>

            <tr>
              <td>02-Jan-2020 10:30am</td>
              <td>Abi Booth</td>
              <td>
                <div>+1-202-555-0197</div>
                <div>booth@gmail.com</div>
              </td>
              <td>Haleema Andrews</td>
              <td class="status_1">
                <span>Ok</span>
              </td>
              <td>
                <label class="mdi mdi-clipboard-text-outline" id="declaration-7"></label>
                <b-popover target="declaration-7" triggers="hover" placement="left">
                  <template v-slot:title>Declaration</template>
                  Nunc ut libero mattis, hendrerit tortor vitae, consequat nisi.
                </b-popover>
              </td>
            </tr>

            <tr>
              <td>02-Jan-2020 10:30am</td>
              <td>Zackary Dyer</td>
              <td>
                <div>+1-202-555-0197</div>
                <div>dyer@gmail.com</div>
              </td>
              <td>Franklin Clinton</td>
              <td class="status_2">
                <span>Block</span>
              </td>
              <td>
                <label class="mdi mdi-clipboard-text-outline" id="declaration-8"></label>
                <b-popover target="declaration-8" triggers="hover" placement="left">
                  <template v-slot:title>Declaration</template>
                  Nam pretium quam vel purus tincidunt euismod.
                </b-popover>
              </td>
            </tr>

            <tr>
              <td>02-Jan-2020 10:30am</td>
              <td>Lex Sosa</td>
              <td>
                <div>+1-202-555-0197</div>
                <div>viola@gmail.com</div>
              </td>
              <td>Ellis Morrow</td>
              <td class="status_1">
                <span>Ok</span>
              </td>
              <td>
                <label class="mdi mdi-clipboard-text-outline" id="declaration-9"></label>
                <b-popover target="declaration-9" triggers="hover" placement="left">
                  <template v-slot:title>Declaration</template>
                  Fusce eget libero eu libero vestibulum auctor.
                </b-popover>
              </td>
            </tr>

            <tr>
              <td>02-Jan-2020 10:30am</td>
              <td>Cherise Leal</td>
              <td>
                <div>+1-202-555-0197</div>
                <div>leal@gmail.com</div>
              </td>
              <td>Joseph Davis</td>
              <td class="status_1">
                <span>Ok</span>
              </td>
              <td>
                <label class="mdi mdi-clipboard-text-outline" id="declaration-10"></label>
                <b-popover target="declaration-10" triggers="hover" placement="left">
                  <template v-slot:title>Declaration</template>
                  Duis fringilla orci vitae arcu imperdiet egestas.
                </b-popover>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Visitors",
  components: {},
  data() {
    return {
      left_filter: false,
      multiselect: null
    };
  },
  mounted() {},
  methods: {
    table_filter: function() {
      if (this.left_filter == false) {
        this.left_filter = true;
      } else {
        this.left_filter = false;
      }
    }
  }
};
</script>
